<template>
    <div class="TreeselectDemo">
        <RPTreeselect
            v-model="singleSelect"
            :options="treeselectData"
            placeholder="Location Select"
        />
        <RPTreeselect
            v-model="selected"
            :options="treeselectData"
            placeholder="Location Select"
            :multiple="true"
        />
        <RPTreeselect
            v-model="disabledSelect"
            :options="treeselectData"
            placeholder="Location Select"
            :disabled="true"
        />
    </div>
</template>
<script>
import RPTreeselect from 'components/Complex/Treeselect/RPTreeselect.vue';
export default {
    name: 'TreeselectDemo',
    components: {
        RPTreeselect,
    },
    data(){
        return {
            singleSelect: null,
            selected: [],
            disabledSelect: null,
            treeselectData: [
                {
                    "id": "brand-3",
                    "label": "Sed",
                    "children": [
                        {
                            "id": "region-4",
                            "label": "Ea",
                            "children": [
                                {
                                    "id": "location-1",
                                    "label": "Stehr-Tromp - 0"
                                },
                                {
                                    "id": "location-8",
                                    "label": "Stehr-Tromp - 7"
                                },
                                {
                                    "id": "location-9",
                                    "label": "Stehr-Tromp - 8"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "brand-4",
                    "label": "Voluptatem",
                    "children": [
                        {
                            "id": "region-6",
                            "label": "Pariatur",
                            "children": [
                                {
                                    "id": "location-2",
                                    "label": "Stehr-Tromp - 1"
                                },
                                {
                                    "id": "location-3",
                                    "label": "Stehr-Tromp - 2"
                                },
                                {
                                    "id": "location-5",
                                    "label": "Stehr-Tromp - 4"
                                }
                            ]
                        },
                        {
                            "id": "region-5",
                            "label": "Architecto",
                            "children": [
                                {
                                    "id": "location-7",
                                    "label": "Stehr-Tromp - 6"
                                }
                            ]
                        },
                        {
                            "id": "region-7",
                            "label": "Odit",
                            "children": [

                            ]
                        }
                    ]
                },
                {
                    "id": "brand-5",
                    "label": "Sed",
                    "children": [
                        {
                            "id": "region-8",
                            "label": "Ea",
                            "children": [
                                {
                                    "id": "location-4",
                                    "label": "Stehr-Tromp - 3"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "brand-1",
                    "label": "At",
                    "children": [
                        {
                            "id": "region-1",
                            "label": "Rerum",
                            "children": [
                                {
                                    "id": "location-6",
                                    "label": "Stehr-Tromp - 5"
                                },
                                {
                                    "id": "location-10",
                                    "label": "Stehr-Tromp - 9"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "brand-2",
                    "label": "Modi",
                    "children": [
                        {
                            "id": "region-2",
                            "label": "Possimus",
                            "children": [

                            ]
                        },
                        {
                            "id": "region-3",
                            "label": "Nostrum",
                            "children": [

                            ]
                        }
                    ]
                }
            ]
        };
    }
};
</script>
<style lang="scss">
    .TreeselectDemo {
        height: 100%;
        padding: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
</style>
